import { IQueryContext } from 'framework/context/IQueryContext';
import { IExactOnlineCustomerAccountDto, IExactOnlineCustomerAccountQueryParams, IQueryResult } from 'gen/ApiClient';
import React from 'react';

export const ExactOnlineCustomerAccountsQueryContext = React.createContext<
	IQueryContext<IQueryResult<IExactOnlineCustomerAccountDto>, IExactOnlineCustomerAccountQueryParams>
>(undefined as any);
